import { Button, Form, Input } from 'antd'
import './index.less'
import { useEffect, useState } from 'react';
import { ReactComponent as SelectSvg } from '../icons/select.svg'

const { TextArea } = Input;

interface Iprops {
    id: number
}

export default function WorkOrderDetailPanel(props: Iprops) {
    const { id } = props;
    const [form] = Form.useForm(); // 表单
    const [loading, setLoading] = useState<boolean>(false); // 创建按钮的loading

    useEffect(() => {
        generateData();
    }, [id])

    // 查询工单详情
    const generateData = () => {
        // todo 查询工单详情，填到表单里
        // todo 获得对象的基本信息，填到表单里
        const data = null;
        form.setFieldsValue({
            ...data,
        })
    }

    return (
        <div className="send-work-container">
            <Form
                colon={false}
                form={form}
                autoComplete="off"
            >
                <Form.Item label="工单名称" name="title" >
                    <TextArea className="grey-text-input" />
                </Form.Item>
                <Form.Item label="对象" name="name" >
                    <Input className="grey-input short" readOnly />
                    <SelectSvg className="select-icon" />
                </Form.Item>
                <Form.Item label="路径" name="path" >
                    <Input className="grey-input" readOnly />
                </Form.Item>
                <Form.Item label="功能" name="function" >
                    <TextArea className="grey-text-input" readOnly />
                </Form.Item>
                <div className="divider">问题</div>
                <Form.Item label="描述" name="problem" >
                    <TextArea className="grey-text-input" readOnly />
                </Form.Item>
                <Form.Item label="任务目标" name="target" >
                    <TextArea className="grey-text-input" readOnly />
                </Form.Item>
                <div className="divider">执行方</div>
                <Form.Item label="完成人" name="executor" >
                    <TextArea className="grey-text-input" readOnly />
                </Form.Item>
                <Form.Item label="承接单位" name="undertakingUnit" >
                    <TextArea className="grey-text-input" readOnly />
                </Form.Item>
                <div style={{ flex: '1 1 auto' }}></div>
                <Button className="send-work-order-btn">上传</Button>
            </Form>
        </div>
    )
}